<template>
  <div class="app-container">
    <div class="app-header">
      <div class="menu-top">
        <div class="menu-top-l" :style="{marginLeft: isCollapse ? '15px' : '30px'}" @click="changeMenuCollapse">
          <i class="iconfont icon-menu-list" />
          <div v-show="!isCollapse" class="icon-text">
            <span class="smart">互联网医院处方流转平台</span>
            <span class="medical">Medical</span>
          </div>
        </div>
        <div class="menu-top-r">
          <span class="help-center">帮助中心</span>
          <span class="message-center">消息中心</span>
          <el-dropdown @command="handleDropdown">
            <span class="el-dropdown-link">
              <span>{{ loginName }}</span>
              <i class="el-icon-arrow-down el-icon-caret-bottom" style="margin-left: 6px;" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="app-body">
      <div class="menu-l" :style="{width: menuWidth}">
        <el-menu
          :default-active="defaultActiveRoute"
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          text-color="#333333"
          active-text-color="#43AAB7"
          :router="true"
          :collapse-transition="false"
        >
          <el-menu-item v-for="(item,index) in menuLeft" :key="index" :index="item.route">
            <i class="iconfont left-icon" :class="item.icon" />
            <span slot="title" class="menu_title">{{ item.title }}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="main-container">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import bus from '@/bus'
export default {
  data() {
    return {
      isCollapse: false, // 导航栏是否向右收起
      menuWidth: '200px',
      loginName: '', // 登录人名称
      menuLeft: []
    }
  },
  computed: {
    defaultActiveRoute() {
      const menu = this.menuLeft.find(item => {
        return this.$route.path.includes(item.route)
      })
      const route = menu ? menu.route : undefined
      return route
    }
  },
  created() {
    const menuArr = [{
      route: '/home',
      title: '首页概览',
      icon: 'icon-home-page'
    }]
    const routeArr = ['/home', '/pharmacist/pharmacistDrugList', '/pharmacist/pharmacistDrugDetails', '/pharmacist/synchronousHospitalDrag','/pharmacist/hospitalDrugAssociation']
    const buttonPermission = []
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.loginName = this.userInfo.loginName
    const menuList = this.userInfo.authInfoDTOS || []
    menuList.forEach(v => {
      menuArr.push({
        icon: v.icon,
        route: v.path,
        title: v.authName,
        authInfo: v.authList
      })
      routeArr.push(v.path)
      if (v.authList.length) {
        v.authList.forEach(auth => {
          buttonPermission.push(auth.permission)
          if (auth.paths.length) {
            auth.paths.forEach(path => {
              routeArr.push(path)
            })
          }
        })
      }
    })
    this.menuLeft = menuArr
    const menuRouterArr = [...new Set(routeArr)]
    localStorage.setItem('ADMIN_MENU_ROUTER', JSON.stringify(menuRouterArr))
    localStorage.setItem('BUTTON_PERMISSION', JSON.stringify(buttonPermission))
  },
  mounted() {
    bus.$on('change-user-info', () => {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.loginName = this.userInfo.loginName
    })
  },
  beforeDestroy() {
    bus.$off(['change-user-info'])
  },
  methods: {
    // 隐藏左侧菜单
    changeMenuCollapse() {
      this.isCollapse = !this.isCollapse
      this.menuWidth = this.isCollapse ? '64px' : '220px'
    },
    // 下拉菜单事件
    handleDropdown(command) {
      if (command === 'logout') {
        this.$api.USER.logout({ accountId: this.userInfo.accountId }).then(res => {
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push({
            name: 'login'
          })
        }).catch(err => {
          console.log('err', err)
        })
      }
    }

  }
}
</script>
<style scoped lang="less">
.app-container {
  min-width: 1350px;
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
  height: 100%;
  color: #333;
  align-items: center;

  .app-header {
    background-color: #fff;
    height: 56px;
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 15px;

    .menu-top {
      width: 1350px;
      min-width: 1350px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .menu-top-l {
        display: flex;
        align-items: center;

        .iconfont {
          margin-right: 10px;
          font-size: 30px;
        }

        .icon-text {
          display: flex;
          flex-direction: column;

          .smart {
            font-size: 18px;
            font-weight: bold;
          }

          .medical {
            font-size: 9px;
            font-weight: bold;
          }
        }
      }

      .menu-top-r {
        display: flex;
        align-items: center;

        .help-center,
        .message-center {
          cursor: pointer;
          margin-right: 20px;
        }

        .el-dropdown-link {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .app-body {
    width: 1350px;
    min-width: 1350px;
    display: flex;
    flex: 1;
    overflow-y: hidden;
    padding-bottom: 30px;

    .menu-l {
      background-color: #fff;
      margin-right: 20px;

      .el-menu {
        border-right-width: 0;
      }

      .el-menu-item {
        text-align: center;
        box-sizing: border-box;
        border-left: 3px solid #fff;

        &.is-active {
          background-color: #ecf6f8;
          border-left-color: #43aab7;

          &:hover {
            border-left-color: #43aab7;
          }
        }

        &:hover {
          border-left-color: #ecf6f8;
        }
      }
    }

    .main-container {
      flex: 1;
      overflow-x: hidden;
    }

    .left-icon {
      margin-right: 10px;
    }

    .el-menu-item * {
      vertical-align: baseline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue